const useStyles = theme => ({
  headerContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    [theme.breakpoints.only('md')]: {
      paddingTop: 15,
      paddingBottom: 20,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
  backTextBox: {
    marginLeft: 4,
    height: 24,
    [theme.breakpoints.down('sm')]: {
      visibility: 'hidden',
      height:0,
      width: 0,
    },
  },
  backButton: {
    borderRadius: 20,
    marginTop: -5,
    marginLeft: 10,
    height: 25,
    width: 25,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  backArrow: {
    position: 'absolute',
    height: 25,
    width: 15
  },
  backText: {
    marginLeft: 5,
    [theme.breakpoints.down('sm')]: {
      visibility: 'hidden',
      height:0,
      width: 0,
    }
  },
  logoContainer: {
    padding: 0,
    marginLeft: 12,
  },
  logoButton:{
    padding: 0,
  },
  logo: {
    height: 40,
    objectFit: 'cover',
    width: 'auto',
    [theme.breakpoints.only('md')]: {
      height: 25,
    },
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  linkItemContainer: {
    borderBottom: 'none',
    paddingLeft: 15,
    paddingRight: 0,
    paddingBottom: 0,
    paddingTop: 0,
  },
  linksButton: {
    padding: '10px 0px 0px 0px',
    borderRadius: 15,
    [theme.breakpoints.only('md')]: {
      padding: '5px 0px 0px 0px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0px 0px 0px',
    },
  },
  linkText: {
    textTransform: 'none',
    width: 'max-content'
  },
  navigationCategoriesContainer: {
    overflow: 'hidden',
    '&::-webkit-scrollbar' : {
      display: 'none'
    }
  }
});

export default useStyles
